// parameterSystem.js

export function evaluateExpression(expr, params = {}) {
  const str = String(expr ?? "").trim();
  if (!str) return { ok: true, value: "" };

  const direct = Number(str);
  if (!Number.isNaN(direct)) return { ok: true, value: direct };

  if (Object.prototype.hasOwnProperty.call(params, str)) {
    return { ok: true, value: params[str] };
  }

  try {
    const keys = Object.keys(params);
    const values = keys.map((k) => Number(params[k]) || 0);

    const fn = new Function(...keys, `return (${str});`);
    const result = fn(...values);

    if (!Number.isFinite(result)) {
      return { ok: false, value: "", message: "Invalid result" };
    }

    return { ok: true, value: result };
  } catch {
    return { ok: true, value: str };
  }
}

export function resolveParameterValue({
  key,
  project = {},
  type = {},
  bindings = {},
  constraints = {},
  instance = {},
  parent = {},
}) {
  if (instance[key] !== undefined) {
    return { value: instance[key], source: "instance" };
  }

  if (constraints[key] !== undefined) {
    return { value: constraints[key], source: "constraint" };
  }

  if (bindings[key] !== undefined) {
    return { value: bindings[key], source: "binding" };
  }

  if (type[key] !== undefined) {
    return { value: type[key], source: "type" };
  }

  if (project[key] !== undefined) {
    return { value: project[key], source: "project" };
  }

  if (parent[key] !== undefined) {
    return { value: parent[key], source: "parent" };
  }

  return { value: undefined, source: "none" };
}

export function resolveAllParameters({
  project = {},
  type = {},
  bindings = {},
  instance = {},
  parent = {},
  constraints = {},
}) {
  const keys = new Set([
    ...Object.keys(project || {}),
    ...Object.keys(parent || {}),
    ...Object.keys(type || {}),
    ...Object.keys(bindings || {}),
    ...Object.keys(instance || {}),
    ...Object.keys(constraints || {}),
  ]);

  const result = {};
  const debug = {};

  const baseContext = {
    ...(project || {}),
    ...(parent || {}),
  };

  keys.forEach((key) => {
    const resolved = resolveParameterValue({
  key,
  project,
  type,
  bindings,
  constraints,
  instance,
  parent,
});

    const context = {
      ...baseContext,
      ...result,
    };

    const evaluated = evaluateExpression(resolved.value, context);

    result[key] = evaluated.ok ? evaluated.value : "";

    debug[key] = {
      source: resolved.source,
      raw: resolved.value,
      evaluated: result[key],
      error: evaluated.ok ? null : evaluated.message,
    };
  });

  return {
    effectiveParameters: result,
    debug,
  };
}

export function validateParameters(payload) {
  const resolved = resolveAllParameters(payload);

  const errors = Object.entries(resolved.debug || {})
    .filter(([, info]) => info?.error)
    .map(([key, info]) => ({
      key,
      message: info.error,
      raw: info.raw,
      source: info.source,
    }));

  return {
    ok: errors.length === 0,
    errors,
    effectiveParameters: resolved.effectiveParameters,
  };
}